export default {
  defaultErrorTitle: "We’re sorry.",
  defaultErrorDirections: "Please correct the following errors:",
  invalidCreds: "This login combination is invalid.",
};
